<template>
    <div v-show="canShow()" class="map-marker-categories" :class="{'map-marker-categories--open': open}">
        <button class="map-marker-categories__toggle" aria-expanded="false" @click="toggleCategories"></button>
            
            
        <ul class="map-marker-categories__list">
            <li
                v-for="(category, index) in categories"
                :key="index"
                class="map-marker-categories__item"
            >
                <input
                    type="checkbox"
                    :id="`map-marker-category-${index}`"
                    v-model="category.enabled"
                    class="map-marker-categories__checkbox"
                >
                <label
                    :for="`map-marker-category-${index}`"
                    class="map-marker-categories__label"
                    :title="category.name"
                >
                    {{ category.name }}
                    <span class="map-marker-categories__icon" :style="{ backgroundColor: category.color }">
                        <img
                            v-if="category.icon"
                            :src="category.icon"
                            :alt="category.name"
                            class="map-marker-categories__icon-image"
                        />
                    </span>
                </label>
            </li>
        </ul>
    </div>

</template>
<script setup>
import { ref } from 'vue';

const props = defineProps({
    // The marker categories, keyed by type. Each entry is mutated in place by the
    // checkboxes below, so the parent's reactive object is never reassigned.
    categories: {
        type: Object,
        required: true,
    },
});

const open = ref(false);

// Toggle the categories display
const toggleCategories = () => {
    open.value = !open.value;
};

// Only show the categories if there are more than one
const canShow = () => {
    return Object.keys(props.categories).length > 1;
};
</script>